<template>
  <div>
    <Head title="Orders" />
    <div class="flex items-center justify-between">
      <h1 class="text-3xl font-bold">Orders</h1>
    </div>
    <div class="flex items-center justify-between mb-3">
      <!--<search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <label class="block text-gray-700">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>-->
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left">
            <th class="pb-4 pt-6 px-3">PO#</th>
            <th class="pb-4 pt-6 px-6">Site Name</th>
            <th class="pb-4 pt-6 px-6">Projected</th>
            <th class="pb-4 pt-6 px-6">Building</th>
            <th class="pb-4 pt-6 px-6">Floor</th>
            <th class="pb-4 pt-6 px-6">Vendor/Bid</th>
            
          </tr>
        </thead>
        <tbody>
          <template v-for="purchaseorder in jobsiteorders" :key="purchaseorder.id">
            <template v-if="((auth.user.vendor == purchaseorder.vendor) || (auth.user.vendor == 0))">
            <tr :class="(purchaseorder.ordertype == 1) ? 'purchaseorder truss' : 'purchaseorder'">
              <td class="border-t">
                <span class="flex items-center px-3 py-2 focus:text-indigo-500">
                  PO# {{ pad(purchaseorder.id) }} {{ (purchaseorder.ordertype == 1) ? '[Truss]' : '' }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-2 focus:text-indigo-500" >
                  <!-- {{ getJobsiteName(purchaseorder.jobsite_id) }} -->
                  {{ purchaseorder.ordertype }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-2"  tabindex="-1">
                  {{ moment(purchaseorder.order_date).format('MM/DD/YYYY') }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-2" tabindex="-1">
                {{ formatdate(purchaseorder.projected_delivery) }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-2 font-bold" tabindex="-1">
                  {{ (purchaseorder.ordertype == 'TRUSS') ? ('Building ' + purchaseorder.building) : '&nbsp;' }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-2 font-bold" tabindex="-1">
                  {{ (purchaseorder.ordertype == 'TRUSS') ? (purchaseorder.floor == 'Roof' ? 'Roof' : 'Level ' + purchaseorder.floor) : '&nbsp;' }}
                </span>
              </td>
              <td class="border-t">
                <span class="flex items-center px-6 py-2" tabindex="-1">
                   {{ purchaseorder.bid_id }}
                </span>
              </td>
              <td class="w-px border-t">
                <!--<Link class="flex items-center px-4"  tabindex="-1"  >
                <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>-->
                <Link v-if="(auth.user.role == 'ADMIN')" class="btn-indigo mr-5" :href="'/orders/create/?po=' + purchaseorder.id + '&js=' + purchaseorder.jobsite_id">
                  <span>Create Order</span>
                  <span class="hidden md:inline">&nbsp;for PO#{{ pad(purchaseorder.id) }}</span>
                </Link>
              </td>
            </tr>
            <tr class="suborders text-left font-bold">
              <th class="pb-2 pt-2 px-3">Order#</th>
              <th class="pb-2 pt-2 px-3"></th>
              <th class="pb-2 pt-2 px-3">Order Date</th>
              <th class="pb-2 pt-2 px-3">Proj. Delivery</th>
              <th class="pb-2 pt-2 px-3"></th>
              <th class="pb-2 pt-2 px-3"></th>
              <th class="pb-2 pt-2 px-3"></th>
              <th class="pb-2 pt-2 px-3"></th>
            </tr>
            <template v-for="order in orders.data" >
              <tr v-if="order.purchaseorder_id == purchaseorder.id" class="suborders text-right ">
                <td class="border-t">
                  <Link class="flex items-center px-3 py-4 focus:text-indigo-500" :href="`/orders/${order.id}/edit`">
                    {{ pad(order.id) }}
                  </Link>
                </td>
                <td>&nbsp;</td>
                <td class="border-t">
                  <Link class="flex items-center px-6 py-4"  tabindex="-1" :href="`/orders/${order.id}/edit`">
                    {{ moment(order.order_date).format('MM/DD/YYYY') }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-6 py-4" tabindex="-1" :href="`/orders/${order.id}/edit`">
                  {{ formatdate(order.cutoff_date) }}
                  </Link>
                </td>
                <td class="border-t">
                  <Link class="flex items-center px-6 py-4" tabindex="-1" :href="`/orders/${order.id}/edit`">
                  <!-- {{ purchaseorder.vendor }} -->
                  </Link>
                </td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
            </template>
            <tr class="lastrow"><th>&nbsp;</th></tr>
            </template>
          </template>

          <td class="border-t">
            <span class="flex items-center px-6 py-4" tabindex="-1">
              <!--{{ formatdate(order.projected_delivery) }}-->
            </span>
          </td>

          <tr v-if="purchaseorders.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No orders found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="purchaseorders.links" />
  </div>
      <div id="updatejobsite" @click="filterOrders"></div>
</template>
<style>
.purchaseorder {background:#bbbbbb; }
tr.purchaseorder { transition:200ms; background:#c9e6ee; cursor:default; }

.suborders { padding:0 30px; background:#dce7ea; font-size:14px; border-bottom:1px dotted #CCC; }
.suborders.font-bold { padding:0 10px; background:#BBB; border-bottom:2px solid #777; }
tr.suborders:not(.font-bold):hover { background:#FFF; color:#117892;}
tr.lastrow { line-height:40px; }
tr.truss {background:rgb(189, 185, 177)};
</style>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import moment from 'moment'

export default {
  mounted() {
    this.filterOrders()
  },
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    orders: Object,
    jobsites: Object,
    auth: Object,
    purchaseorders: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
      },
      moment: moment,
      filteredjobsites: this.authjobsites(),
      jobsiteorders: [],
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/orders', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    filterOrders() {
      var jsid = document.querySelector('#jobsiteselector').value;
      var ordersyes = [];
      this.purchaseorders.data.forEach((ord) => {
        if (parseInt(ord.jobsite_id) == parseInt(jsid)) {
          ordersyes.push(ord);
        }
      });
      this.jobsiteorders = ordersyes;
    },
    authjobsites() {
      var jsa = JSON.parse(this.auth.user.jobsiteaccess);
      var jobsitesyes = [];
      this.jobsites.data.forEach((js) => {
        if (jsa[js.id] == 1) {
          jobsitesyes.push(js);
        }
      });
      return jobsitesyes;
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    getJobsiteName(order_jobsite_id) {
      var jsn = '';
      this.jobsites.data.forEach((jobsite) => {
        if (jobsite.id == order_jobsite_id) { jsn = jobsite.sitename; }
      })
      return jsn;
    },
    formatdate(dv) {
      if (dv) {
        return moment(dv).format('MM/DD/YYYY');
      } else { return ""; }
    },
    pad(n) {
      return n.toString().padStart(5,"0");
    },
  },
}
</script>
